/**
 * Generates a shareable link for the provided tracker IDs.
 *
 * This function takes an array of tracker IDs, appends them as a query parameter (`trackerIds`)
 * to the `/admin/trackers` URL, and returns the fully constructed URL string.
 *
 * @param {string[]} trackerIds - An array of tracker IDs to include in the shareable link.
 * @returns {string} The generated shareable URL including the `trackerIds` query parameter.
 */
export const createTrackerShareLink = (trackerIds: Array<string>) => {
  const url = new URL('/admin/trackers', window.location.origin);
  url.searchParams.append('trackerIds', trackerIds.join(','));
  return url.toString();
};
